import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

const ServiceCard = ({ icon, title, description, delay }) => {
    const [ref, inView] = useInView({
        triggerOnce: true,
        threshold: 0.1,
    });

    return (
        <motion.div
            ref={ref}
            initial={{ opacity: 0, y: 50 }}
            animate={inView ? { opacity: 1, y: 0 } : { opacity: 0, y: 50 }}
            transition={{ duration: 0.5, delay: delay ?? 0 }}
            className="bg-white rounded-lg shadow-md p-8 flex flex-col items-center text-center h-full border border-gray-100 hover:shadow-xl transition-shadow duration-300"
        >
            <div className="text-arcdom-gold text-5xl mb-5">{icon}</div>
            <h3 className="text-xl font-semibold text-arcdom-navy mb-3">{title}</h3>
            <p className="text-gray-600 text-sm leading-relaxed">{description}</p>
        </motion.div>
    );
};

export default ServiceCard;
